import { Link } from "react-router-dom";
import useSEO from "@/hooks/useSEO";
import { STATIC_ROUTE_META } from "@/utils/routeMetadata";
import EmergencyGuideLinks from "@/components/letters/EmergencyGuideLinks";
import FamilyMembership from "@/components/funnel/FamilyMembership";

export default function ElfHelp() {
  useSEO(STATIC_ROUTE_META["/elf-help"]);
  return (
    <div className="bg-white">
      <header className="bg-elfGreen-light px-4 py-12 md:py-16"><div className="mx-auto max-w-4xl"><Link to="/" className="text-sm text-elfGreen-ink underline">Home</Link><h1 className="mt-6 text-3xl font-bold md:text-5xl">Quick help for Christmas elf surprises</h1><p className="mt-4 max-w-2xl text-lg leading-relaxed">A forgotten move, a late arrival, or a curious little hand: find a calm answer and a short note you can use today.</p></div></header>
      <div className="mx-auto max-w-5xl px-4 pb-14"><EmergencyGuideLinks /><p className="mb-8 text-sm text-slate-700">Planning a farewell instead? Use our <Link to="/blog/holiday-elf-departure-letters-guide/" className="font-semibold text-elfGreen-ink underline">existing elf goodbye letter guide</Link>.</p><FamilyMembership source="elf-help-hub" title="Let your elf tell the next part of the story" /></div>
    </div>
  );
}
